import * as React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import useMainStore from '../../store/store';
import { usePWAContext } from './PWAProvider';
import Logo from '../logo';
import Iconify from '../iconify';

function InstallPopupPWA() {
  // @ts-ignore
  const { onInstallAction } = usePWAContext();
  const setShowInstallPWA = useMainStore((state) => state.setShowInstallPWA);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 20,
        left: 0,
        width: '100%',
        height: 'fit-content',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          height: 'fit-content',
          width: 'fit-content',
          paddingBottom: '8px',
          borderRadius: '8px',
          background: (theme) => theme.palette.background.paper,
          boxShadow: '0 0 12px rgba(0,0,0,0.2)',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            size="small"
            color="inherit"
            onClick={() => {
              setShowInstallPWA(false);
            }}
            sx={{ color: 'text.secondary' }}
          >
            <Iconify icon="eva:close-fill" width={16} />
          </IconButton>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '48px',
              minWidth: '48px',
              height: '48px',
              background: (theme) => theme.palette.background.paper,
              boxShadow: '0 0 2px rgba(0,0,0,0.3)',
              borderRadius: '6px',
              marginRight: '10px',
            }}
          >
            <Logo style={{ width: '32px', height: '32px' }} />
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '60px',
              justifyContent: 'center',
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontSize: (theme) => '1.125rem',
                margin: '3px 10px 5px 0',
                lineHeight: 1,
                color: (theme) => theme.palette.text.primary,
              }}
            >
              ActiveRevenue
            </Typography>
            <Typography
              sx={{
                fontSize: (theme) => theme.typography.subtitle2 || '0.75rem',
                lineHeight: 1.2,
                marginRight: '10px',
                fontWeight: 300,
                WebkitTextStroke: '1px rgba(0, 0, 0, 0.05)',
                color: (theme) => theme.palette.text.secondary,
                display: {
                  xs: 'none',
                  md: 'block',
                },
              }}
            >
              This website has app functionality. Add it to your home screen for a better experience
            </Typography>
          </Box>

          <Box
            component="div"
            onClick={() => onInstallAction()}
            id="installPWA"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              height: '37px',
              marginLeft: 'auto',
              marginRight: '8px',
              padding: '6px 16px',
              background: (theme) => theme.palette.background.default,
              color: (theme) => theme.palette.primary.main,
              borderRadius: '6px',
              whiteSpace: 'nowrap',
              cursor: 'pointer',
              '&:hover': {
                opacity: 0.9,
              },
            }}
          >
            <Typography sx={{ fontSize: '1.025rem !important' }}>Install</Typography>
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: (theme) => theme.typography.subtitle2 || '0.75rem',
            lineHeight: 1.2,
            marginLeft: '26px',
            marginRight: '10px',
            fontWeight: 300,
            WebkitTextStroke: '1px rgba(0, 0, 0, 0.05)',
            color: (theme) => theme.palette.text.secondary,
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          This website has app functionality.
          <br />
          Add it to your home screen for a better experience
        </Typography>
      </Box>
    </Box>
  );
}

export default InstallPopupPWA;
